
//原始状态

   const state = {
     api:'//www.originoo.com/api/',
     api_li:'//www.originoo.com/api/',//李
     api_tian:'//www.originoo.com/api/',//田舟
     api_chen:'//www.originoo.com/api/',//陈
     api_shi:'//www.originoo.com/api/',//时
     api_hu:'//www.originoo.com/api/'
   };


//用方法处理由state中派生出的状态
//即此状态在state中不存在 如 state中含 list 中{} 的参数
const getters = {
  
  
};
//方法集合 操作状态 state 的集合

const mutations = {




};
//actions提交的是mutations 而不是直接改变状态
//而是通过mutations中的方法去修改
//可以异步操作
const actions = {


//add(context,params){
//  //console.log(context,params,'参数','执行actions的add');
//  context.commit('add',params)
//},
//add({commit},params){
//  //console.log(params,'参数','执行actions的reduce');
//  commit('reduce',params)
//},

};


export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/api.js